import React, { useState } from "react";

const FAQItem = ({ question, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mb-4 border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm transition-all duration-300">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex justify-between items-center font-semibold bg-gray-100 py-3.5 px-5 text-left transition-colors duration-300 hover:bg-gray-200/80 text-primary focus:outline-none"
      >
        <span className="pr-4">{question}</span>
        <span className={`text-[10px] text-gray-500 transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}>
          ▼
        </span>
      </button>
      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isOpen ? "max-h-[600px] opacity-100 py-4 px-5 border-t border-gray-100" : "max-h-0 opacity-0 py-0 px-5"
        }`}
      >
        <div className="text-secondary leading-relaxed text-sm lg:text-base">
          {children}
        </div>
      </div>
    </div>
  );
};

const FAQ = () => {
  return (
    <div>
      <div>
        <section class="text-primary">
          <div class="container px-5 py-24 mx-auto">
            <div class="text-center mb-20">
              <h1 class="h2 mb-6 xl:mb-12">
                Frequently Asked Question
              </h1>
              <p class="lead text-center ">
                Semua pertanyaan yang sering ditanyakan oleh pelanggan kami ada di sini, kalau kamu punya pertanyaan lain, kamu bisa langsung tanya ke kami.
              </p>
            </div>
            <div class="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
              <div class="w-full lg:w-1/2 px-4 py-2">
                <FAQItem question="Pengerjaannya berapa hari?">
                  Normally, pengerjaan olah data bisa selesai dalam waktu 2-4
                  hari karena ada antrian. Tapi kalau kamu urgent banget harus
                  kelar besoknya, kita bisa kok siapin paket express buat
                  kamu. Kamu cuma nambah 20% aja dari harga yang sudah
                  disepakati.
                </FAQItem>
                <FAQItem question="Hasil olah datanya beneran akurat?">
                  Pastinya!!! Tim kami dilead oleh statistician lulusan
                  Amerika Serikat yang udah biasa menghadapi klien ga cuma
                  dari Indonesia tapi juga dari luar negeri loh!
                </FAQItem>
                <FAQItem question="Nanti diajarin nggak cara ngolah datanya?">
                  Bisa donk! Jadi setelah teman-teman mengirimkan datanya,
                  dalam waktu 2-4 hari, teman-teman akan kami ajak meeting
                  untuk kami ajarkan cara pengolahan datanya dari awal sampai
                  bagaimana cara membacanya!
                </FAQItem>
                <FAQItem question="Kalo hasilnya nggak sesuai harapan gimana?">
                  Kita akan bantu menemukan metode yang tepat sesuai dengan
                  kondisi data kamu. Kami tidak akan memanipulasi data alias
                  ngubah-ngubah data apapun karena kan ga boleh ya… Instead,
                  kami akan bantu mencarikan justifikasi yang bisa kamu pakai
                  buat menghadapi sidang.
                </FAQItem>
                <FAQItem question="Kalo ada revisi gimana? Bayar lagi nggak?">
                  Temen-temen dapat GRATIS revisi minor kok. Kecuali kalau
                  berubah total dari awal (bahkan data dan tujuan
                  penelitiannya ganti), nanti ada charge 50% dari harga yang
                  sudah disepakati.
                </FAQItem>
              </div>
              <div class="w-full lg:w-1/2 px-4 py-2">
                <FAQItem question="Firstat bisa melayani aplikasi statistik apa aja?">
                  Kita bisa bantu analisa data kamu dengan program statistik
                  apa aja, mulai dari SPSS, R, Python, SmartPLS, MPlus,
                  EVIEWS, SAS, STATA.
                </FAQItem>
                <FAQItem question="Bisa ketemu offline nggak?">
                  Ooo bisa dong!!! hubungin aja dulu, kalo Tuhan mengizinkan
                  kita bisa ketemu kok di mana pun kamu berada. Soalnya, tim
                  konsultan kami tersebar di berbagai kota di Indonesia.
                </FAQItem>
                <FAQItem question="Cara pemesanannya gimana?">
                  <div class="flex flex-col space-y-4">
                    <p class="text-lg font-medium">
                      Cara Memulai Projek Analisis Data
                    </p>
                    <ol class="list-decimal list-inside space-y-2">
                      <li>
                        Hubungi kontak kami melalui WA, telepon, atau email
                        yang sudah tertera
                      </li>
                      <li>
                        Free konsultasi untuk mengetahui apakah projek kamu
                        memungkinkan untuk kami kerjakan
                      </li>
                      <li>
                        Kamu akan diminta untuk mengirimkan bab 1,2 dan 3 atau
                        setidaknya hipotesis penelitian serta data set
                      </li>
                      <li>Kamu melakukan 50% pembayaran</li>
                      <li>
                        Proses pengerjaan analisis akan memakan waktu selama 1
                        - 3 hari
                      </li>
                      <li>
                        Hasil analisis akan disampaikan atau didiskusikan
                        melalui meeting (online/offline)
                      </li>
                      <li>Kamu melakukan sisa 50% pembayaran</li>
                      <li>
                        Ketika pembayaran sudah diterima, hasil, laporan dan
                        lampiran akan dikirimkan melalui email
                      </li>
                    </ol>
                  </div>
                </FAQItem>
                <FAQItem question="Metode pembayarannya gimana?">
                  Untuk saat ini kami hanya menggunakan transfer bank untuk
                  metode pembayaran. Kamu boleh bayar 50% dulu di awal ketika
                  kita sudah deal, dan 50% sisanya bisa kamu bayarkan setelah
                  dapat hasilnya.
                </FAQItem>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FAQ;
